import { FilterNames } from '../types/trade';

const date = new Date();
const currentYear = date.getFullYear();

export const YEAR = {
  min: 1980,
  max: currentYear + 1
};

export const ODOMETER = {
  min: 0,
  max: 205000
};

export const MILEAGE = {
  min: 0,
  max: 1000000
};

export enum HeaderType {
  Base = 'base',
  Controlled = 'controlled'
}

export const FilterArrow = {
  position: 'right',
  color: 'white',
  size: 10
};

export const CacheKeys = {
  selectedFilter: 'selected-filters',
  filterList: 'filter-list',
  selectedSortOption: 'selected-sort',
  selectedNetworkOption: 'selected-network',
  sortOptions: 'sort-options'
};

export enum InputListDefinitions {
  locations = 0,
  conditions = 1
}

export const Distances = [50, 150, 150, 250, 500, 750, 1000, 1500, 2000];

export const Year = {
  floor: 1980,
  futureYears: 1,
  step: 1
};

export const Mileage = {
  floor: 0,
  ceil: 200000,
  step: 5000
};

export const FilterOrder = [
  FilterNames.all.type,
  FilterNames.watchlist.type,
  FilterNames.default.type,
  FilterNames.custom.type,
  FilterNames.impound.type,
  FilterNames.independent.type,
  FilterNames.franchise.type
];

export enum FilterType {
  Location = 'locations',
  Distance = 'distances',
  BuyerAddress = 'buyerAddresses',
  YearRange = 'yearRange',
  Manufacturer = 'manufacturers',
  Model = 'models',
  MileageRange = 'mileageRange',
  TransmissionType = 'transmissionTypes',
  FuelType = 'fuelTypes',
  Condition = 'conditions',
  TradeCondition = 'tradeConditions'
}

export enum FilterPillsList {
  Province = 'provinces',
  Distance = 'locationFilter',
  ModelYear = 'modelYear',
  Make = 'modelTrims',
  Model = 'model',
  MileageRange = 'mileage',
  TransmissionType = 'transmissionTypes',
  FuelType = 'fuelTypes',
  OmitAsIs = 'omitAsIs',
  OmitHistory = 'omitHistory',
  OmitAmount = 'omitAmount',
  IsInStock = 'isInStock',
  IsFloorPriceMet = 'isFloorPriceMet',
  IsFranchiseDealer = 'isFranchiseDealer'
}

export const MixpanelFilterName = {
  provinces: 'location',
  locationFilter: 'transport_distance',
  modelYear: 'year',
  modelTrims: 'makes',
  model: 'models',
  mileage: 'mileage',
  transmissionTypes: 'transmission',
  fuelTypes: 'fuel_type',
  omitAsIs: 'hide_as_is',
  omitHistory: 'hide_with_accident',
  omitAmount: 'hide_with_3000',
  isInStock: 'instock_only',
  isFloorPriceMet: 'is_floor_met',
  isFranchiseDealer: 'franchise_only'
};
